// removed by extract-text-webpack-plugin
module.exports = {"container":"AppointmentSubmitPage__container___3bQHYtc","btnWrapper":"AppointmentSubmitPage__btnWrapper___1Nf7hxL","btnBox":"AppointmentSubmitPage__btnBox___3rG47Ji"};